export default "__VITE_ASSET__19bc3915__"